const OPEN_DROPDOWN = "OPEN_DROPDOWN";
const CHECK_OPTION = "CHECK_OPTION";
const UNCHECK_OPTION = "UNCHECK_OPTION";
const CLOSE_DROPDOWN = "CLOSE_DROPDOWN";
const CHECK_PILL_CAPTURE = "CHECK_PILL_CAPTURE";
const CLEAR_FILTERS = "CLEAR_FILTERS";
const SHOW_PROMPT = "SHOW_PROMPT";
const SHOW_ALL_CLICK = "SHOW_ALL_CLICK";
const SHOW_ALL_POPULAR = "SHOW_ALL_POPULAR";
const SHOW_ALL_CAPTURES = "SHOW_ALL_CAPTURES";

export {
  OPEN_DROPDOWN,
  CHECK_OPTION,
  UNCHECK_OPTION,
  CLOSE_DROPDOWN,
  CHECK_PILL_CAPTURE,
  CLEAR_FILTERS,
  SHOW_PROMPT,
  SHOW_ALL_CLICK,
  SHOW_ALL_POPULAR,
  SHOW_ALL_CAPTURES,
};
